import { createStore } from "redux";
import { reducer } from "./reducer";
import { persistStore, persistReducer } from "redux-persist";
import storage from 'redux-persist/lib/storage'
const persistConfig = {
  key: "aauserToken",
  storage: storage,
  whitelist: ['isUserLogin',
    'guestToken', 'userToken',
    'userDetails', 'familydetails', 'whatsappOptInState',
    'subscriptionData', 'walletDetails',
    'orderList', 'consultationList',
    'selectedLocation', 'pharmacyAllData',
    'cartItemsData', 'cartImagesData', 'orderInstructions',
    'previousSelectedLocation', 'previousSelectedMedicine', 'previousSelectedMedicineCategory',
  ]
};

const persistedReducer = persistReducer(persistConfig, reducer)

// const store= createStore(reducer)

export const store = createStore(persistedReducer)
export const persistor = persistStore(store)
// export default store;